/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './procedure-episode.reducer';

export const ProcedureEpisodeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const procedureEpisodeEntity = useAppSelector(state => state.procedureEpisode.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="procedureEpisodeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.procedureEpisode.detail.title">ProcedureEpisode</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.id">Id</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.name">Name</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.description">Description</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.description}</dd>
          <dt>
            <span id="order">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.order">Order</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.order}</dd>
          <dt>
            <span id="durationAfterPrevious">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.durationAfterPrevious">Duration After Previous</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.durationAfterPrevious}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.active">Active</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.procedureEpisode.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{procedureEpisodeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureEpisode.procedure">Procedure</Translate>
          </dt>
          <dd>{procedureEpisodeEntity.procedure ? procedureEpisodeEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/procedure-episode" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/procedure-episode/${procedureEpisodeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProcedureEpisodeDetail;
